/**
 * RESPONSIBILITY: draw the picture across the top of an event's page, at one size.
 *
 * ONE SIZE ON EVERY EVENT. The box is fixed and the picture adapts to it, never the other
 * way round — letting each upload set the header's shape made every event page a
 * different height and a tall poster a wall of picture.
 *
 * A BANNER is made for the box, so it fills it. With none, the event's card picture is
 * used instead, and that one is usually a poster with the date and the address printed
 * to its edges: cropping it to the box cut the address in half. So it is FITTED whole,
 * over a blurred copy of itself, which fills the sides with the picture's own colour
 * rather than leaving two empty bars.
 */
import { hasImage } from '@framework/core';
import type { EventRow } from '@app/sections';
import { Picture } from '../commons/Picture';

export function EventBanner({ e }: { e: EventRow }) {
  if (hasImage(e.bannerImage) || !hasImage(e.image)) {
    return (
      <div className="ev-top">
        <Picture value={hasImage(e.bannerImage) ? e.bannerImage : e.image} alt="" className="ev-top-cover" />
      </div>
    );
  }

  return (
    <div className="ev-top">
      <Picture value={e.image} alt="" className="ev-top-fill" />
      <Picture value={e.image} alt="" className="ev-top-fit" />
    </div>
  );
}
